import { useConstructorContextState } from './useConstructorContextState';
import { get } from 'lodash';

export const useGetRedirect = (): string => {
  const state = useConstructorContextState();

  return get(state, ['redirect'], '_blank');
};
